import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbTooltipModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/user';
import { EntityService } from '../../../services/entity.service';
import { getCurrentUserId } from '../../../helpers/utils';
import { Profil } from '../../../models/profil';
import { EditProfileModalComponent } from './edit-profile-modal/edit-profile-modal.component';
import { NotificationService } from '../../../services/notification.service';
import { SecureStorageService } from '../../../services/secure-storage.service';

@Component({
  selector: 'app-admin-header',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, NgbTooltipModule],
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
  user: User | null = null;
  userId: string | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private entityService: EntityService,
    private modalService: NgbModal,
    private notificationService: NotificationService,
    private secureStorage: SecureStorageService
  ) {}

  ngOnInit() {
    this.userId = getCurrentUserId();
    this.loadUserData();
  }

  private loadUserData() {
    if (this.userId) {
      this.entityService.getDataById<User>('/users', this.userId).subscribe({
        next: (user: User) => {
          this.user = user;
          if (!this.secureStorage.getItem('user')) {
            this.secureStorage.setItem('user', user);
          }    
          console.log(this.user);
        },
        error: (error) => {
          console.error('Erreur lors du chargement des données utilisateur:', error);
        }
      });
    }
  }

  editProfile() {
    const modalRef = this.modalService.open(EditProfileModalComponent, {
      size: 'lg',
      centered: true
    });
    modalRef.componentInstance.user = this.user;

    modalRef.result.then((result) => {
      if (result) {
        this.entityService.updateDataWithPost('/users', this.user?.id, result).subscribe({
          next: () => {
            this.notificationService.success('Profil mis à jour avec succès');
            this.loadUserData();
          },
          error: (error) => {
            console.error('Erreur lors de la mise à jour:', error);
            this.notificationService.error('Erreur lors de la mise à jour du profil');
          }
        });
      }
    }).catch(() => {});
  }

  openSettings() {
    this.router.navigate(['/admin/settings']);
  }

  logout() {
    this.secureStorage.clear();
    this.router.navigate(["/admin/login"]);
  }
} 